import script from "./SlideBuilding.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideBuilding.vue?vue&type=script&lang=ts&setup=true"

import "./SlideBuilding.vue?vue&type=style&index=0&id=4eba3860&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eba3860"]])

export default __exports__